@if (form && validationContext) {
  <rask-container-block [formGroup]="form">
    <div class="row">
      <rask-selector
        class="col-lg-4"
        label="Grund produktinstruktion"
        aid="grundproduktinstruktion"
        [(ngModel)]="grundProduktinstruktionViewModel"
        [ngModelOptions]="{standalone: true}"
        [values]="valdaProduktinstruktioner"
        [viewFormatter]="produktinstruktionViewFormatter"
        [reverseLookup]="false"
        (change)="produktinstruktionChanged()"
        [disabled]="!canChangeProduktintruktion()">
      </rask-selector>
      <div class="col-lg-4">
        <rask-label class="selected-pin-table-header" size="12">Valda produktinstruktioner</rask-label>
        <rask-table [data]="valdaProduktinstruktioner" [columns]="tableColumns" [noScroll]="true"></rask-table>
        <rask-input
          class="col-2 version-select"
          label="Version"
          [rule]="validationContext.current.version"
          formControlName="version"
          (change)="versionsnummerChanged()">
        </rask-input>
        <rask-checkbox
          class="col-4 version-select"
          text="Alla produktinstruktioner"
          [(ngModel)]="versionsNummerForAllaPuid"
          [ngModelOptions]="{standalone: true}"
          (change)="versionsnummerCheckboxChanged($event)">
        </rask-checkbox>
      </div>
      <div class="col-lg-4">
        <div class="row">
          <rask-input-number
            class="col-4"
            label="Max längd"
            unit="cm"
            [required]="true"
            [rule]="validationContext.current.maxlangd"
            formControlName="maxlangd">
          </rask-input-number>
          <rask-input-number
            class="col-4"
            label="Max toppdiameter"
            unit="mm"
            [required]="true"
            [rule]="validationContext.current.maxdiameter"
            formControlName="maxdiameter">
          </rask-input-number>
        </div>
        <div class="row">
          <rask-input
            class="col-4"
            label="Skapad datum"
            formControlName="skapadDatum"
            [readonly]="true">
          </rask-input>
          <rask-input
            class="col-4"
            label="Ändrad datum"
            formControlName="andradDatum"
            [readonly]="true">
          </rask-input>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 mt-auto">
        @if (hasAlerts) {
          <rask-message-panel
            class="col-4"
            [numberOfItemsToDisplay]="3"
            [maxNumOfRows]="3"
            [labels]="messageLabels"
            [items]="validationMessages$">
          </rask-message-panel>
        }
      </div>
    </div>
  </rask-container-block>
}
